module.exports = __webpack_public_path__ + "static/media/n4.2afa6d94.jpg";